import { IAppState } from '../../../AppModulesWrapper';

export function selectIsAutobrokerEnabled(state: IAppState): boolean {
  const {
    auction: {
      strategy: { isEnabled },
    },
  } = state.servicePickerWidget;

  return isEnabled;
}
